// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

import { plansTranslationsEn } from './plansTranslations.en.js';
export const plansTranslationsRu = {
  ...plansTranslationsEn,
  'plans.founder.remaining': 'Осталось {count} мест Founder',
  'plans.founder.remaining_last': 'Последние {count} мест Founder',
  'plans.founder.remaining_limited': 'Ограничено: осталось {count}',
  'plans.founder.remaining_very_low': 'Осталось только {count} мест Founder',
  'plans.founder.soldout': 'Founder распродан',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.compare.pro.adjustment_notice': 'Цена может быть скорректирована в зависимости от условий сервиса.',
  'plans.compare.title': 'Choose your plan',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.foundation.badge': '150 limited slots',
  'plans.compare.cta.foundation': 'Become a Founder',
  'plans.compare.cta.pro': 'Upgrade to PRO',
  'plans.compare.active': 'Current plan',
  'plans.compare.limited': '',
  'plans.limit.title.messages': 'Message limit reached',
  'plans.limit.message.messages': 'You reached your message limit. Upgrade to FOUNDATION or PRO.',
  'plans.limit.title.storage': 'Storage limit reached',
  'plans.limit.message.storage': 'You reached your storage limit. Upgrade to upload more files.',
  'plans.limit.title.invitations': 'Invitation limit reached',
  'plans.limit.message.invitations': 'You reached your invitation limit. Upgrade to invite more.',
  'plans.limit.reached': 'Limit reached — Upgrade plan',
  'plans.compare.institucional.title': 'Title',
  'plans.compare.yourPlan': 'YourPlan',
  'plans.modal.title': 'Обновить план',
  'plans.modal.comparison_title': 'Сравнение планов',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.modal.free.line1': '30 000 символов в месяц на аккаунт.',
  'plans.modal.free.line2': 'До 2 контактов на пользователя.',
  'plans.modal.free.line3': 'До 2 активных бесед на аккаунт.',
  'plans.modal.free.line4': 'Без вложений и места для хранения.',
  'plans.modal.free.line5': 'Без экспорта данных.',
  'plans.modal.free.line6': 'История сообщений до 30 дней.',
  'plans.modal.free.line7': 'Только 1 устройство на пользователя.',
  'plans.modal.premium.line1': '300 000 символов в месяц на аккаунт.',
  'plans.modal.premium.line2': 'До 100 контактов на пользователя.',
  'plans.modal.premium.line3': 'Неограниченные беседы и чаты (tenant).',
  'plans.modal.premium.line4': 'До 50 МБ хранилища (tenant).',
  'plans.modal.premium.line5': 'До 3 устройств на пользователя.',
  'plans.modal.premium.line6': 'Неограниченные приглашения (tenant).',
  'plans.modal.premium.line7': 'Включает экспорт, автоперевод и файлы в пределах лимитов плана.',
  'plans.modal.premium_block_heading': 'Лимиты использования движка (premium)',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'Программа Founder',
  'plans.modal.foundation.categories_title': 'Категории Founder ({slots} мест)',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': 'Позиция 1–25',
  'plans.modal.foundation.cat_legendary_desc': 'Первые, кто поддержал проект. Максимальный исторический приоритет.',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': 'Позиция 26–75',
  'plans.modal.foundation.cat_early_desc': 'Ранняя поддержка с особым признанием.',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': 'Позиция 76–150',
  'plans.modal.foundation.cat_std_desc': 'Место Founder в рамках 150 позиций.',
  'plans.modal.foundation.advantages_title': 'Преимущества Founder',
  'plans.modal.foundation.adv1': 'Доступ к ограниченному пулу Founder ({slots} нумерованных мест).',
  'plans.modal.foundation.adv2': 'Признание как основательского пользователя ArChat.',
  'plans.modal.foundation.adv3': 'Значок и статус Founder в продукте.',
  'plans.modal.foundation.adv4': 'Исторический приоритет и статус по позиции (1–150).',
  'plans.modal.foundation.adv5': 'Постоянная выгода, связанная с доступом Founder, пока действует текущая политика.',
  'plans.modal.pro.tagline': 'Стандартный premium — без компонента Founder',
  'plans.badges.foundation': 'Founder',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': 'Бесплатный план',
  'plans.free.features.contacts': 'До 2 контактов на пользователя',
  'plans.free.features.conversations': 'До 2 активных бесед на аккаунт',
  'plans.free.features.no_export': '30 000 символов/мес. на аккаунт; 34 сообщ./день и 1000/мес.; без экспорта',
  'plans.free.features.no_advanced': 'Без файлов и хранилища; история 30 дней; 1 устройство на пользователя',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'План Founder',
  'plans.foundation.features.contacts': 'Тот же премиум-контракт, что PRO (до 100 контактов на пользователя)',
  'plans.foundation.features.conversations': 'Безлимитные чаты (tenant); те же лимиты, что у PRO',
  'plans.foundation.features.badge': 'Программа Founder (150 нумерованных мест)',
  'plans.foundation.features.support': 'USD 15/мес., пока есть места Founder',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'План Pro',
  'plans.pro.features.contacts': 'До 100 контактов на пользователя',
  'plans.pro.features.conversations': 'Безлимитные чаты (tenant); 1667 сообщ./день, 50 тыс./мес.',
  'plans.pro.features.export': 'До 50 МБ (tenant); экспорт, автоперевод и файлы по плану',
  'plans.pro.features.notifications': 'До 3 устройств на пользователя; безлимитные приглашения (tenant)',
  'plans.actions.free': 'Текущий план',
  'plans.actions.foundation': 'Стать Founder',
  'plans.actions.pro': 'Перейти на PRO',
  'plans.badges.recommended': 'РЕКОМЕНДУЕТСЯ',
  'plans.badges.limited': 'ОГРАНИЧЕНО',
  'plans.payments_disabled.title': 'Подписки',
  'plans.payments_disabled.message': 'Подписки активируются постепенно. Вы можете просмотреть доступные планы и их преимущества.',
  'plans.payments_disabled.confirm': 'OK',
};